<script setup lang="ts">
import { ArrowUpRight } from "@lucide/vue";
import { computed } from "vue";
import { formatDate, getDisplaySummary, getDisplayTitle, getPrimaryLabel, getRecordSection, SECTION_LABELS } from "../lib/content";
import type { ContentRecord } from "../types/content";

const props = defineProps<{ record: ContentRecord; position?: number }>();
const section = computed(() => getRecordSection(props.record));
</script>

<template>
  <article class="content-row" :class="`content-row-${section}`">
    <div class="content-row-meta">
      <span v-if="position" class="content-row-index">{{ String(position).padStart(2, "0") }}</span>
      <span>{{ getPrimaryLabel(record) }}</span>
      <small>{{ SECTION_LABELS[section] }}</small>
    </div>
    <div class="content-row-body">
      <RouterLink class="content-title" :to="`/entry/${record.id}`">{{ getDisplayTitle(record) }}</RouterLink>
      <p>{{ getDisplaySummary(record) }}</p>
      <div class="row-status">
        <span>更新于 {{ formatDate(record.last_reviewed_at) }}</span>
        <span v-if="record.published_at">发布于 {{ formatDate(record.published_at) }}</span>
      </div>
    </div>
    <RouterLink class="row-action" :to="`/entry/${record.id}`" :aria-label="`查看 ${record.title}`" title="查看详情"><ArrowUpRight :size="18" /></RouterLink>
  </article>
</template>
